import { buildCsvFromRows } from '../../../shared/csv-core/infra/buildCsv';
import { formatAuditEventLabel, type AuditLogRow } from '../../../shell/audit/auditLogs';
import { categorizeEventType, AUDIT_CATEGORY_LABELS } from '../../../shell/audit/auditCategories';
import { getAuditListSubtitle } from '../../../shell/audit/auditLogPresentation';
import { formatAuditWhen } from '../../teamUtils';

type ResolveUserLabel = (userId: string | null) => string | null;

export function buildTeamHistoryCsv(
  rows: AuditLogRow[],
  resolveUserLabel: ResolveUserLabel,
): string {
  const headers = ['Fecha', 'Usuario', 'Categoría', 'Evento', 'Detalle', 'Metadata'];
  const dataRows = rows.map((row) => {
    const userLabel = resolveUserLabel(row.user_id) ?? row.user_id ?? '';
    const category = AUDIT_CATEGORY_LABELS[categorizeEventType(row.event_type)];
    const eventLabel = formatAuditEventLabel(row.event_type);
    const detail = getAuditListSubtitle(row) ?? '';
    const metadata = JSON.stringify(row.metadata ?? {});
    return [formatAuditWhen(row.created_at), userLabel, category, eventLabel, detail, metadata];
  });
  return buildCsvFromRows(headers, dataRows);
}
